import { render } from "./CurrentRound.vue?vue&type=template&id=302862d2"
import script from "./CurrentRound.vue?vue&type=script&lang=js"
export * from "./CurrentRound.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__